let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("04egH")).then(() => parcelRequire('fBdRZ'));